export default __webpack_public_path__ + "static/media/Erlik's Blade of Widows.a391e0d4.jpg";